import { equals } from '@execonline-inc/collections';
import { when } from '@execonline-inc/maybe-adapter';
import { observer } from 'mobx-react';
import InviteTimeForm from '../../../../SharedComponents/InviteTimeForm';
import SkipInvitation from '../../../../SharedComponents/SkipInvitation';
import { InviteParticipantStoreActions } from '../RenderInviteParticipantsModal';
import { Inviting, Submitting } from '../Types';
import Form from './Form';
import SkipCommunications from './SkipCommunications';
import Submit from './Submit';

export interface Props {
  state: Inviting | Submitting;
  actions: InviteParticipantStoreActions;
}

function InviteModalBody({ actions, state }: Props) {
  return (
    <>
      <SkipCommunications
        skipCommunications={state.skipCommunications}
        setSkipCommunications={actions.setSkipCommunications}
      />
      {when(equals(true), state.skipCommunications)
        .map(() => <SkipInvitation />)
        .getOrElseValue(
          <InviteTimeForm>
            <Form actions={actions} state={state} />
          </InviteTimeForm>,
        )}
      <Submit actions={actions} />
    </>
  );
}

export default observer(InviteModalBody);
